import React, { PureComponent } from 'react';
import RadioButtonParticularGeographicCode from "./RadioButtonParticularGeographicCode";

const LabelDomicilioCuenta = ({ domicilio }) => {
    
    if (!domicilio)
        return null;

    if (domicilio.Direccion.hasOwnProperty('Calle') && domicilio.Direccion.hasOwnProperty('Numero')) {

      const domicilioCuenta = domicilio.Direccion.CodigoDomicilio + " - " +
            domicilio.Direccion.Calle + " " +
            domicilio.Direccion.Numero + ", " +
            domicilio.Direccion.Localidad + ", " +
            domicilio.Direccion.CodigoPostal + ". (Telefono: " +
           (domicilio.Telefono.Caracteristica != "" ? domicilio.Telefono.Caracteristica + "-" : "") +
           domicilio.Telefono.Numero + ")";

      return <label className="label-secondary">{domicilioCuenta}</label>;
   }
   else {
      return <label className="alert-danger">{domicilio}</label>;
   }

}

class SelectDomicilioParticular extends PureComponent {

    render() {

      const { domicilio, GET_CODIGO_GEOGRAFICO, Validaciones, ValidarPantalla, Cuenta, form, guardarCampoCuenta } = this.props;

      return (
      <div className="row top-separator-xs">
        <div className="col-xs-12">
          <div>
            <label className="label-primary">Domicilio particular</label>
          </div>
          <div>
            <LabelDomicilioCuenta domicilio={domicilio} />
          </div>
          {domicilio &&
                <RadioButtonParticularGeographicCode
                    GET_CODIGO_GEOGRAFICO={GET_CODIGO_GEOGRAFICO}
                    Validaciones={Validaciones}
                    ValidarPantalla={ValidarPantalla}
                    Cuenta={Cuenta}
                    form={form}
                    domicilio={domicilio}
                    guardarCampoCuenta={guardarCampoCuenta}
                />
            }
         </div>
       </div >
       );

    }
    
}

export default SelectDomicilioParticular;